const register = {
  loginCredentials: "Credenciais de login", // translated
  companyInformation: "Informações da Empresa", // translated
  contactDetails: "Detalhes do contato", // translated
  businessName: "Nome da empresa", // translated
  businessAddress: "Endereço profissional", // translated
  registrationCode: "Código de Registo", // translated
  businessRegistrationNumber: "Número de registo comercial", // translated
  websiteUrl: "URL do site", // translated
  mobilePhone: "Celular", // translated
  regionStateProvince: "Região/Estado/Província", // translated
  legalTitle: "Título legal", // translated
  city: "Cidade", // translated
  postalCode: "Código postal", // translated
  registrationSuccess: "Registro bem sucedido.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Aguarde alguns instantes e você será redirecionado para a página inicial.", // translated
  usernameEmail: "Nome de utilizador (e-mail)", // translated
  password: "Palavra-passe", // translated
  verifyPassword: "Verificar palavra-passe", // translated
  documents: "Documentos", // translated
  termsAndConditionsSection: "Termos e condições", // translated
  certificateOfIncorporation: "Certidão de constituição", // translated
  acceptTermsAndConditions: "Aceitar termos e condições", // translated
  country: "País", // translated
  brandName: "Marca", // translated
  register: "Registar", // translated
  isRequired: "É necessário", // translated
  passwordMin8Chars: "Deve ter pelo menos 8 caracteres", // translated
  passwordRequiresDigit: "Deve conter pelo menos 1 dígito", // translated
  passwordRequiresLowercase: "Deve conter pelo menos 1 letra minúscula", // translated
  passwordRequiresUppercase: "Deve conter pelo menos 1 letra maiúscula", // translated
  passwordRequiresSpecialChar: 'Deve conter pelo menos 1 carácter especial (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Carregar ficheiro", // translated
  filename: "Nome do ficheiro:", // translated
  fileType: "Tipo:", // translated
  fileSize: "Tamanho:", // translated
  maxFileSize10Mb: "Máx.: 10 MB", // translated
  supportedFileTypes: "Tipos de ficheiro suportados:", // translated
  showPassword: "Mostrar palavra-passe", // translated
  hidePassword: "Ocultar palavra-passe", // translated
  notAvailable: "N/D", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "ex.: +351912345678", // translated
  websiteUrlPlaceholder: "http://www.exemplo.com", // translated
  loading: "A carregar...", // translated
  uploadingDocument: "A carregar documento...", // translated
  percentUploaded: "{{percent}}% carregado", // translated
  registrationSuccessful: "Registo concluído com sucesso.", // translated
  failedToUploadDocument: "Falha ao carregar o documento.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} deve ter mais de {{min}} caracteres", // translated
  fieldMustBeValidEmail: "{{field}} deve ser um e-mail válido", // translated
  fieldPasswordMinLength: "{{field}} deve ter pelo menos 8 caracteres", // translated
  fieldPasswordRequiresDigit: "{{field}} deve conter pelo menos 1 dígito", // translated
  fieldPasswordRequiresLowercase: "{{field}} deve conter pelo menos 1 letra minúscula", // translated
  fieldPasswordRequiresUppercase: "{{field}} deve conter pelo menos 1 letra maiúscula", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} deve conter pelo menos 1 carácter especial (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} não corresponde a {{otherField}}", // translated
  fieldBetweenLength: "{{field}} deve ter entre {{min}} e {{max}} caracteres", // translated
  postalCodeBetweenLength: "{{field}} deve ter entre {{min}} e {{max}} caracteres", // translated
  invalidUrlFormat: "Formato de URL inválido", // translated
  invalidEmailFormat: "Formato de e-mail inválido", // translated
  emailMustMatchUsername: "o e-mail deve ser igual ao nome de utilizador (e-mail)", // translated
  mobilePhoneIsRequired: "O telemóvel é obrigatório", // translated
  certificateFileTooLarge: "O certificado de constituição é demasiado grande", // translated
  termsMustBeAccepted: "Os termos e condições devem ser aceites", // translated
};


export default register;
